import 'flatpickr/dist/flatpickr.min.css';

import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import Loading from '@oto-web/shared/components/global/Loading';
import { initializeApp } from '@oto-web/shared/utils/initApp';

import App from './App';

initializeApp();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<React.Fragment>
		<Suspense fallback={<Loading />}>
			<App />
		</Suspense>
	</React.Fragment>
);
